import config from '@/config'
import jwtDecode from 'jwt-decode'
import { AccessToken } from 'types'

const logout = async () => {
  await fetch(`${config.endpoints.auth}/logout`, {
    method: 'POST',
    credentials: 'include',
  })
  //Use the user's companyId to get the ssoUrl
  const { user } = jwtDecode<AccessToken>(
    sessionStorage.getItem('accessToken') ?? '',
  )
  const res = await fetch(
    `${config.endpoints.graphql}/sso-url/${user.companyId}`,
  )
  const { ssoUrl: ssoUrl } = await res.json()
  const validSSOFormat = ssoUrl?.slice(0, 4).toLowerCase() === 'http'

  localStorage.setItem('LOGGING_OUT', 'true')
  localStorage.removeItem('LOGGING_OUT')
  sessionStorage.clear()
  window.location.href = ssoUrl && validSSOFormat ? ssoUrl : config.webRoot
}

export default logout
